import React, { Component } from "react";
import {
  DataGrid,
  FilterRow,
  Editing,
  Column,
  Paging,
  Pager,
  Lookup,
  StateStoring,
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label, EmptyItem } from "devextreme-react/form";
import { Button } from "devextreme-react";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarCadastroModelos } from "../../DataSources";
import uiInfo from "../../ui-info";

const localStorageKey = "cadastroEntregaNotificacaoDiatGridState";

export default class CadastroModelosBox extends Component {
  constructor() {
    super();
    this.state = { filtro: {}, fieldsAmount: 1 };
    this._gridInstance = React.createRef();
    this._formInstance = React.createRef();

    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);

    this.fieldsAmountOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [1, 2, 3],
      onValueChanged: (e) => this.setState({ fieldsAmount: e.value }),
    };

    this.selectorOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: [
        { id: true, descricao: "SIM" },
        { id: false, descricao: "NÃO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("cadastro-modelos/editar/" + e.data.id);
  }

  filtrar(e) {
    let filtro = this.state.filtro;

    let filtroCorrente = [];

    if (filtro.qtdeCampos) {
      filtroCorrente.push(["qtdeCampos", "=", filtro.qtdeCampos]);
    }

    if (filtro.nome) {
      filtroCorrente.push(["nome", "contains", filtro.nome.trim()]);
    }

    if (filtro.titulo) {
      filtroCorrente.push(["titulo", "contains", filtro.titulo.trim()]);
    }

    if (filtro.tipoValidacao) {
      filtroCorrente.push([
        "tipoValidacao",
        "contains",
        filtro.tipoValidacao.trim(),
      ]);
    }

    if (filtro.legendaCampo1) {
      filtroCorrente.push([
        "legendaCampo1",
        "contains",
        filtro.legendaCampo1.trim(),
      ]);
    }

    if (filtro.instrucaoCampo1) {
      filtroCorrente.push([
        "instrucaoCampo1",
        "contains",
        filtro.instrucaoCampo1.trim(),
      ]);
    }

    if (filtro.legendaCampo2) {
      filtroCorrente.push([
        "legendaCampo2",
        "contains",
        filtro.legendaCampo2.trim(),
      ]);
    }

    if (filtro.instrucaoCampo2) {
      filtroCorrente.push([
        "instrucaoCampo2",
        "contains",
        filtro.instrucaoCampo2.trim(),
      ]);
    }

    if (filtro.legendaCampo3) {
      filtroCorrente.push([
        "legendaCampo3",
        "contains",
        filtro.legendaCampo3.trim(),
      ]);
    }

    if (filtro.instrucaoCampo3) {
      filtroCorrente.push([
        "instrucaoCampo3",
        "contains",
        filtro.instrucaoCampo3.trim(),
      ]);
    }

    if (filtroCorrente.length > 0) {
      this._gridInstance.instance.filter(filtroCorrente);
    } else {
      this._gridInstance.instance.clearFilter();
    }

    this._gridInstance.instance.refresh();
  }

  limparFiltro(e) {
    this.setState({ filtro: {} });
    this._formInstance.instance.repaint();
    this.filtrar();
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <form onSubmit={this.filtrar}>
          <Form
            id="frmPesquisa"
            ref={(x) => (this._formInstance = x)}
            formData={this.state.filtro}
            colCount={3}
            labelLocation={"top"}
          >
            <SimpleItem dataField={"nome"} colSpan={2}>
              <Label text="Nome" />
            </SimpleItem>
            <SimpleItem dataField={"titulo"}>
              <Label text="Título" />
            </SimpleItem>
            <SimpleItem dataField={"tipoValidacao"}>
              <Label text="Tipo de Validação" />
            </SimpleItem>
            <SimpleItem
              dataField={"qtdeCampos"}
              editorType={"dxLookup"}
              editorOptions={this.fieldsAmountOptions}
            >
              <Label text="Quantidade de Campos" />
            </SimpleItem>
            <EmptyItem colSpan={1} />
            <SimpleItem dataField={"legendaCampo1"}>
              <Label text="Legenda do Campo 1" />
            </SimpleItem>
            <SimpleItem dataField={"instrucaoCampo1"} colSpan={2}>
              <Label text="Instrução do Campo 1" />
            </SimpleItem>
            <SimpleItem
              dataField={"legendaCampo2"}
              visible={this.state.fieldsAmount >= 2}
            >
              <Label text="Legenda do Campo 2" />
            </SimpleItem>
            <SimpleItem
              dataField={"instrucaoCampo2"}
              visible={this.state.fieldsAmount >= 2}
              colSpan={2}
            >
              <Label text="Instrução do Campo 2" />
            </SimpleItem>
            <SimpleItem
              dataField={"legendaCampo3"}
              visible={this.state.fieldsAmount === 3}
            >
              <Label text="Legenda do Campo 3" />
            </SimpleItem>
            <SimpleItem
              dataField={"instrucaoCampo3"}
              visible={this.state.fieldsAmount === 3}
              colSpan={2}
            >
              <Label text="Instrução do Campo 3" />
            </SimpleItem>
          </Form>
          <div
            style={{
              marginTop: "30px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                icon="filter"
                width={120}
                text="Filtrar"
                type="success"
                onClick={this.filtrar}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button
                icon="clear"
                text="Limpar Filtro"
                onClick={this.limparFiltro}
              />
            </div>
          </div>
        </form>

        <PaginaToolbar
          titulo="Cadastro de Modelos"
          novoCb={this.novoRegistro.bind(this)}
        >
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={criarCadastroModelos()}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            columnHidingEnabled={true}
            focusedRowEnabled={true}
            wordWrapEnabled={window.innerWidth < 800}
            filterSyncEnabled={true}
            onEditingStart={this.onAtualizandoRow}
          >
            <StateStoring
              enabled={true}
              type={"localStorage"}
              storageKey={localStorageKey}
            />
            <FilterRow visible={false} />
            <Editing
              allowAdding={false}
              allowDeleting={true}
              allowUpdating={true}
              useIcons={true}
              texts={{
                confirmDeleteMessage:
                  "Ao excluir um modelo que possui implementações nas prefeituras, TODAS as validações baseadas no modelo também serão excluídas. Deseja continuar?",
              }}
            />
            <Column dataField={"id"} caption={"#"} alignment={"center"} />
            <Column dataField={"tipoValidacao"} caption={"Tipo de Validação"} />
            <Column dataField={"nome"} caption={"Nome"} />
            <Column dataField={"titulo"} caption={"Título"} />
            <Column
              dataField={"qtdeCampos"}
              caption={"Qtde. Campos"}
              alignment={"center"}
              width={110}
            />
            <Column dataField={"customizado"} caption={"Customizado"}>
              <Lookup
                dataSource={this.selectorOptions}
                valueExpr={"id"}
                displayExpr={"descricao"}
              />
            </Column>
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("/cadastro-modelos/novo");
  }
}
